import { InfoOutlined } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import PropTypes from 'prop-types'

const InfoTooltip = ({ description }) => {
    return (
        <Tooltip
            title={description}
            placement='top'
            arrow
        >
            <InfoOutlined
                color='info'
                fontSize='small'
            />
        </Tooltip>
    )
}

InfoTooltip.propTypes = {
    description: PropTypes.string
}

export default InfoTooltip